import axiosClient from "../axiosClient"

export function getAllGames(){
    return axiosClient.get('/games/all');
}

export function getTextualContent(params = {}){
    const queryParams = new URLSearchParams();
    
    if (params.game_id) {
        queryParams.append('game_id', params.game_id);
    }
    
    if (params.content_type) {
        queryParams.append('content_type', params.content_type);
    }
    
    const queryString = queryParams.toString();
    const url = queryString ? `/textual-content?${queryString}` : '/textual-content';
    
    return axiosClient.get(url);
}